/*
==========================================================
Salt Hound Theme v4.1B
Editorial Motion Engine
==========================================================
*/

document.addEventListener("DOMContentLoaded", () => {

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(".sh-reveal").forEach(el => {
      el.classList.add("is-visible");
    });
    return;
  }

  const observer = new IntersectionObserver(

    (entries) => {

      entries.forEach(entry => {

        if (!entry.isIntersecting) return;

        reveal(entry.target);

        observer.unobserve(entry.target);

      });

    },

    {
      threshold: 0.18,
      rootMargin: "0px 0px -10% 0px"
    }

  );

  document.querySelectorAll(".sh-editorial").forEach(section => {

    section.querySelectorAll(

      ".sh-editorial__eyebrow," +
      ".sh-editorial__heading," +
      ".sh-editorial__text," +
      ".sh-editorial__button," +
      ".sh-editorial__link," +
      ".sh-image-hover"

    ).forEach(el => {

      el.classList.add("sh-reveal");

      observer.observe(el);

    });

  });

  function reveal(element){

    element.classList.add("is-visible");

  }

});